import moment from 'moment';
import React from 'react'
import { Gift } from 'iconoir-react';

const RefundPromoTable = ({ promos }) => {
  return (
    <div className='card p-0 overflow-hidden'>
      <table className="table-modern">
        <thead>
          <tr>
            <th>User</th>
            <th>Promo Code</th>
            <th>Type</th>
            <th>Value</th>
            <th>Used</th>
            <th>Expires</th>
            <th>Issued</th>
          </tr>
        </thead>
        <tbody>
          {promos && promos.length > 0 ?
            promos.map((promo, index) => {
              const applied_promo = promo.applied_promo || {};
              const user = applied_promo.user || {};
              const promotion = promo.promotion || {};
              return (
                <tr key={promo.id || index}>
                  <td>
                    {user ? (
                      <div className="flex items-center gap-3">
                        <img
                          className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                          src={user.profile_pic}
                          alt=""
                          loading="lazy"
                        />
                        <div>
                          <p className="font-semibold text-surface-800">
                            {user.surname} {user.other_names}
                          </p>
                          <p className="text-xs text-surface-400 capitalize">
                            {user.role}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <span className='text-surface-400 italic'>N/A</span>
                    )}
                  </td>
                  <td>
                    <span className='font-mono font-semibold text-surface-800 bg-surface-100 px-3 py-1 rounded-lg'>
                      {promotion.promo_code}
                    </span>
                  </td>
                  <td>
                    <span className='badge-info'>
                      {promotion.promo_type}
                    </span>
                  </td>
                  <td className='font-semibold text-surface-800'>
                    {promotion.promo_type === 'Percentage'
                      ? `${promotion.value}%`
                      : `GH₵ ${promotion.value?.toFixed(2)}`}
                  </td>
                  <td>
                    {applied_promo.is_active ? (
                      <span className='badge-warning'>Pending</span>
                    ) : (
                      <span className='badge-success'>Used</span>
                    )}
                  </td>
                  <td className='text-surface-500'>
                    {moment(applied_promo.expiry).format('MMM D, YYYY')}
                  </td>
                  <td className='text-surface-500'>
                    {moment(promo.createdAt).format('MMM D, YYYY')}
                  </td>
                </tr>
              )
            }) :
            <tr>
              <td colSpan={7} className="text-center py-12">
                <div className='flex flex-col items-center gap-3'>
                  <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                    <Gift strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                  </div>
                  <div>
                    <p className='font-medium text-surface-600'>No promo refunds</p>
                    <p className='text-sm text-surface-400'>No promotional refunds available</p>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  )
}

export default RefundPromoTable
